module.exports = __webpack_public_path__ + "img/icon5.3cd3f559.png";